import { TITLEREQUEST_STEPS } from "const";
import dayjs from "dayjs";
import { networkErrorHelper, titleRequestService } from "libs";
import React from "react";
import { TitleRequestSignForm } from "./";

export class TitleRequestSign {

    title = 'Firma';
    iconName = 'it-pencil';
    titleRequest = null;
    userProfile = null;
    userCourse = null;
    user = null;
    action = 'Firma richiesta titoli';
    tableName = 'titleRequest';
    _formRef = null;

    constructor() {
        this._formRef = React.createRef();
    }

    setPayload(payload) {        
        this.titleRequest = payload.titleRequest;
        this.userProfile = payload.userProfile;
        this.user = payload.user;
        this.userCourse = payload.userCourse;
    }

    async onNextStep() {
        let canNext = this.canNext = this._formRef.current.validate();

        if (canNext) {
            canNext = await this.updateRemote();
        }

        // ricari la pagina cosi forza il caricamento dei dati da  mnemosine-api e mostra eventuali errori di creazione del titolo 
        if (canNext) {
            window.location.reload();
        }

        return canNext;
    }

    async updateRemote() {

        let retValue = true;
        this.titleRequest.currentStep = TITLEREQUEST_STEPS.PAY;
        this.titleRequest.dateSign = dayjs;

        await titleRequestService.postSign(this.titleRequest)
            .then(() => {
                retValue = true;
            })
            .catch(errors => {
                console.log(errors);
                retValue = false;
                networkErrorHelper.notify(errors);
            });

        return retValue;
    };

    onPrevStep = () => {

        return false;
    }

    render() {

        const validatorProps = {
            action: this.action,
            tableName: this.tableName,
            idParent: this.titleRequest.id,
            phoneNumber: this.userProfile.mobile,
        };

        const requestData = {
            titleRequest: this.titleRequest,
            user: this.user,
            userProfile: this.userProfile,
            userCourse: this.userCourse,
            validatorProps
        };

        return (
            <TitleRequestSignForm
                ref={this._formRef}
                requestData={requestData} />
        );
    }
}